/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Inactive = props => (
  <svg viewBox="0 0 128 128" width="1em" height="1em" {...props}>
    <path d="M103.8 18.9L93 29.6l-6.5-6.5c-1.1-1.1-2.8-1.1-3.9 0s-1.1 2.8 0 3.9l8.5 8.5c.5.5 1.2.8 1.9.8s1.4-.3 1.9-.8l12.7-12.7c1.1-1.1 1.1-2.8 0-3.9-1-1.1-2.7-1.1-3.8 0z" />
    <path d="M94.4 1.3c-15.9 0-28.9 12.9-28.9 28.9 0 15.9 12.9 28.9 28.9 28.9 15.9 0 28.9-12.9 28.9-28.9 0-15.9-13-28.9-28.9-28.9zm0 49.5c-11.4 0-20.6-9.2-20.6-20.6 0-11.4 9.2-20.6 20.6-20.6 11.4 0 20.6 9.2 20.6 20.6 0 11.4-9.2 20.6-20.6 20.6z" />
    <circle cx={27.2} cy={15.6} r={12.4} />
    <path d="M78.5 70.5H50.4c-1 0-2.8-1.4-3-2.3l-7-27.9c-1.5-5.9-7.5-9.5-13.3-8-5.9 1.5-9.5 7.5-8 13.3l7 27.9c2.7 10.8 13.2 19 24.3 19H73v26.3c0 4.6 3.7 8.2 8.2 8.2 4.6 0 8.2-3.7 8.2-8.2V81.5c.1-6.1-4.8-11-10.9-11z" />
    <path d="M61.6 98H48c-12.3 0-25.4-10.3-28.4-22.6l-6.5-25.7c-.6-2.2-2.8-3.6-5-3a4.2 4.2 0 0 0-3 5l6.5 25.7c4 15.9 20.3 28.8 36.4 28.8h13.6c2.3 0 4.1-1.8 4.1-4.1S63.9 98 61.6 98z" />
  </svg>
);

export default extendIcon(Inactive);
